/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
/**
 * WARNING: The files in the src/js/bridges directory are bundle dropins.
 * Please exercise extra caution while modifying paths.
 */

define('explore/contrib/thumbnail/slideout', [ 'explore/bundles/glass.min' ], entry => entry.CardGridSlideout);
define('explore/contrib/cards/extension', [ 'explore/bundles/glass.min' ], entry => entry.CardGridExtension);
define('explore/contrib/pinning/PinView', [ 'explore/bundles/glass.min' ], entry => entry.PinView);

define('explore/bundles/glass.bridge', () => {});
